import axios from "axios";
import { store } from "../../App";
import { IDNumberGenerator } from "../../customFunction/IDGenerator";
import {
  bioCreateUser,
  bioGetUser,
} from "../../db/BioStar/APIs";
import separateFaceIdType from "../../utils/separateFaceIdType";
import { createCredential } from "./credentialsAction";
const GET = "/users";
const CREATE = "/users/create";
const UPDATE = "/users/update";
// const DELETE = "/users/delete";
const smalltalk = require("smalltalk");
export const fetchUsers = async () => {
  try {
    let centerId = localStorage.getItem("centerId");
    centerId = JSON.parse(centerId).centerId;

    const res = await axios.get(`/users?centerId=${centerId}`);
    store.dispatch({ type: "FETCH_USERS", data: res.data });
  } catch (e) {
    console.log(e);
    throw e;
  }
};
export const getBase64Image = async (currentUser) => {
  const centerId = JSON.parse(localStorage.getItem("centerId")).centerId;
  const facesGym = ["66bdca9b7add38fef2918d63", "62d3de0de4b5f62ba339b22d"];
  const faceType = separateFaceIdType()
  if (faceType === 2) return
  const user = await bioGetUser(currentUser.bioStarID);
  if (!user) return;
  if (facesGym.includes(centerId)) {
    //!faces
    if (user.credentials && user.credentials.faces[0] && user.credentials.faces[0].raw_image)
      return (user.credentials.faces[0].raw_image);
  } else {
    return (user?.credentials?.visualFaces[0]?.template_ex_picture || null);
  }
}

export const getUserByBioStarID = async (id) => {
  try {
    const response = await axios.get(`/users/getByBiosStarID/${id}`);
    if (response.data.length === 0) {
      throw { code: -1, message: "User not found" };
    }
    return response.data;
  } catch (e) {
    throw e;
  }
};
export const getGuestByBioStarID = async (id) => {
  try {
    const response = await axios.get(`/cafeteria-guest-users?bioStarID=${id}`);

    if (response.data.length === 0) {
      throw { code: -1, message: "User not found" };
    }
    return response.data;
  } catch (e) {
    throw e;
  }
};
export const updateUser = async (currentUser, shouldOnBiostar,base64) => {
  try {
    let res;
    // if (isUpdate) {
    res = await axios.put(`${UPDATE}/${currentUser._id}`, currentUser);
    if (shouldOnBiostar) {
      await bioCreateUser({ ...currentUser,credentials:base64 }, true);
    }

    // store.dispatch({ type: "ADD_EDIT_USER", data: res.data.data });
    return res.data.data;
  } catch (e) {
    console.log(e)
    throw e;
  }
};
export const editCurrentUser = (currentUser) => {
  try {
    store.dispatch({ type: "EDIT_CURRENT_USER", data: currentUser });
  } catch (e) {
    throw e;
  }
};

export const registerUser = async (registerType, user, membership, advancedPurchase, isUpdateCurrentPackage) => {
  try {
    const res = await axios.post('/users/register-user', { registerType, user, membership, advancedPurchase, isUpdateCurrentPackage })
    store.dispatch({ type: "CLEAR_MEMBERSHIP" });
    return res.data
  } catch (e) {
    console.log(e)
    throw e.response.data
  }
}